export default "__VITE_ASSET__68fdc970__"